import CourseType from '../components/pages/student/course-type.model'

export const generateCourseURL = (url: string, type: CourseType = CourseType.Regular): string => {
  return type === CourseType.Additional ? url.replace('/courses/', '/courses/additional/') : url
}
